// import { useState } from "react";
// import { motion } from "framer-motion";
// import images from '../../images.config';
// import icons from "../../icons.config";

// const Blogs = () => {
//   const initialImages = [
//     { image: images.blog1, alt: "IMAGE 1" , description:"first image description"},
//     { image: images.blog2, alt: "Image 2", description:"second image description" },
//     { image: images.blog3, alt: "Image 3",description:"third image description" },
//     { image: images.blog4, alt: "Image 4",description:"fourth image description" },
//     { image: images.blog5, alt: "Big Image",description:"fifth image description" }, // Initial big image
//   ];

//   const [imageList, setImageList] = useState(initialImages);
//   const [activeImageIndex, setActiveImageIndex] = useState(4); // Index of the big image initially

//   const fadeVariants = {
//     hidden: { opacity: 0 },
//     visible: { opacity: 1, transition: { duration: 0.3 } },
//     exit: { opacity: 0, transition: { duration: 0.5 } },
//   };

//   const handleImageClick = (clickedIndex) => {
//     const newImageList = [...imageList];
//     const bigImage = newImageList[activeImageIndex];
//     const clickedImage = newImageList.splice(clickedIndex, 1)[0];

//     newImageList.splice(activeImageIndex, 1);
//     newImageList.splice(activeImageIndex, 0, clickedImage);
//     newImageList.push(bigImage);
    
//     setImageList(newImageList);
//   };

//   return (
//     <section className="overflow-hidden py-40 relative xl:top-0 bg-tertiary max-h-[910px] md:max-h-full lg:max-h-full">
//       <div className="relative flex flex-col">
//         {/* Left Section: Big Image and Text */}
//         <div className="lg:flex lg:flex-row lg:justify-between py-16 md:py-28 lg:py-0 px-6 lg:px-20">
//           {/* Big Image */}
//           <div className="lg:w-1/2 flex justify-center lg:justify-start relative lg:left-5 lg:-top-8 xl:-top-24 bottom-52 left-5 md:flex md:flex-col md:-top-80 md:-mt-6 z-10">
//             <motion.div
//               key={activeImageIndex}
//               className="relative"
//               variants={fadeVariants}
//               initial="hidden"
//               animate="visible"
//               exit="exit"
//             >
//               <img
//                 src={imageList[activeImageIndex].image}
//                 alt={imageList[activeImageIndex].alt}
//                 className="w-[90%] md:w-[95%] lg:w-[89%] h-[90%] lg:h-screen lg:py-12 object-cover"
//               />
//               {/* Overlay Text */}
//               <div 
//                 className="absolute inset-0 flex flex-col items-start justify-end ml-2 mb-4 lg:top-[69%] bg-red-opacity-80 z-20"
//                 style={{ padding: '50px 16px', maxHeight: '20%', maxWidth: '50%' }}
//               >
//                 <h3 className="text-primary1 text-3xl font-outfit font-light">
//                   {imageList[activeImageIndex].alt}
//                 </h3>
//                 <p className="text-hcolor text-xs font-poppins font-normal mb-0">
//                   {imageList[activeImageIndex].description}
//                 </p>
//               </div>

//               {/* Arrow Icon */}
//               <div className="relative flex flex-col items-end justify-end ml-6 right-[16%] bottom-16 lg:right-[24%] lg:bottom-[19%]">
//                 <img 
//                   src={icons.blogArrow}
//                   alt="Arrow Icon"
//                   className="w-6 h-6 lg:w-9 lg:h-9"
//                 />
//               </div>
//             </motion.div>
//           </div>

//           {/* Text Section */}
//           <div className="lg:w-1/2 mb-16 lg:mb-0 relative md:-mt-12">
//             <div className="relative md:bottom-24 lg:bottom-5 px-3 lg:px-12 left-3 lg:left-1">
//               <h2 className="text-5xl font-outfit font-light text-primary1 mb-6 text-center lg:text-left">
//                 BLOGS
//               </h2>
//               <p className="text-sm text-[#650D1B] font-poppins font-light mb-8 relative top-4 md:pr-2 lg:pr-0">
//                 Explore the latest collections, discover tips or find your perfect fit, and learn about luxurious fabrics. Stay inspired and updated with fresh insights, trending styling tips, expert advice, and famous fashion stories to elevate your wardrobe and upgrade your style.
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Small Images Below Both Sections */}
//         <div className="grid grid-cols-4 gap-x-0 gap-y-8 mx-1 mt-12 lg:mt-0 lg:px-20">
//           {imageList.slice(0, 4).map((img, index) => (
//             <motion.div
//               key={index}
//               className="cursor-pointer transition-opacity duration-500"
//               onClick={() => handleImageClick(index)}
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//             >
//               <motion.img
//                 src={img.image}
//                 alt={img.alt}
//                 className="w-[85%] lg:w-[88%] h-auto"
//                 initial="hidden"
//                 animate="visible"
//                 exit="exit"
//               />
//             </motion.div>
//           ))}
//         </div>
//       </div>

//       {/* Bottom Circles */}
//       <div className="relative left-[78%] md:left-[89%] lg:left-[92%] xl:left-[87%] bottom-44 md:bottom-16 xl:bottom-60">
//         <img 
//           src={icons.blogCirclesDown}
//           alt="Arrow Icon"
//           className="w-24 lg:w-48 xl:w-52"
//         />
//       </div>
//     </section>
//   );
// };

// export default Blogs;

// import { useState } from "react";
// import { motion } from "framer-motion";
// import images from '../../images.config';
// import icons from "../../icons.config";
// import Navbar from '../Navbar/navbar';
// import Footer from '../Footer/footer';
// import { useSwipeable } from 'react-swipeable'; // Import swipeable

// const Blogs = () => {
//   const initialImages = [
//     { image: images.blog1, alt: "IMAGE 1", date: "January 5, 2024", subheading: "Subheading 1", description: "First blog post written by Author 1 Join us on a fashionable journey through personal stories, outfit experiments, and style lessons learned. Our blog shares insights from real fashionistas who navigate the world of clothing, offering inspiration and tips for your own style evolution.Join us on a fashionable journey through personal stories, outfit experiments, and style lessons learned. Our blog shares insights from real fashionistas who navigate the world of clothing, offering inspiration and tips for your own style evolution." },
//     { image: images.blog2, alt: "IMAGE 2", date: "February 12, 2024", subheading: "Subheading 2", description: "Second blog post written by Author 2 Keep your wardrobe in tune with the seasons! Our seasonal style blog explores the must-have clothing items for each time of year. From summer dresses to winter layers, we provide inspiration for dressing stylishly in any weather while keeping comfort in mind.Join us on a fashionable journey through personal stories, outfit experiments, and style lessons learned. Our blog shares insights from real fashionistas who navigate the world of clothing, offering inspiration and tips for your own style evolution." },
//     { image: images.blog3, alt: "IMAGE 3", date: "March 20, 2024", subheading: "Subheading 3", description: "Third blog post written by Author 3 Stay ahead of the curve with our fashion-forward blog! We cover emerging designers, innovative styles, and the latest must-have pieces. Whether you’re looking for high-fashion inspiration or everyday wear, we’ve got you covered with expert advice and trend analysis." },
//     { image: images.blog4, alt: "IMAGE 4", date: "April 15, 2024", subheading: "Subheading 4", description: "Fourth blog post written by Author 4 lorem Ready to revamp your wardrobe? Our blog is dedicated to helping you find your personal style and rejuvenate your clothing collection. We share tips on mixing and matching, accessorizing, and making the most of what you already own. Join us for a style journey that’s both fun and refreshing!Join us on a fashionable journey through personal stories, outfit experiments, and style lessons learned. Our blog shares insights from real fashionistas who navigate the world of clothing, offering inspiration and tips for your own style evolution.Join us on a fashionable journey through personal stories, outfit experiments, and style lessons learned. Our blog shares insights from real fashionistas who navigate the world of clothing, offering inspiration and tips for your own style evolution." },
//     { image: images.blog5, alt: "Big Image", date: "May 1, 2024", subheading: "Subheading 5", description: "Fifth blog post written by Author 5 Dive into the world of eco-friendly fashion with our sustainable clothing blog. We highlight brands that prioritize ethical production, sustainable materials, and stylish designs. Learn how to build a wardrobe that not only looks good but feels good too—because style shouldn’t come at the cost of the planet.Join us on a fashionable journey through personal stories, outfit experiments, and style lessons learned. Our blog shares insights from real fashionistas who navigate the world of clothing, offering inspiration and tips for your own style evolution." }, // Initial big image
//   ];

//   const [imageList, setImageList] = useState(initialImages);
//   const [activeImageIndex, setActiveImageIndex] = useState(4); // Index of the big image initially
//   const [currentIndex, setCurrentIndex] = useState(0); // Index for the small images

//   const fadeVariants = {
//     hidden: { opacity: 0 },
//     visible: { opacity: 1, transition: { duration: 0.3 } },
//     exit: { opacity: 0, transition: { duration: 0.5 } },
//   };

//   const handleImageClick = (clickedIndex) => {
//     const newImageList = [...imageList];

//     // Swap the clicked image with the big image
//     const bigImage = newImageList[activeImageIndex];
//     const clickedImage = newImageList.splice(clickedIndex, 1)[0];

//     newImageList.splice(activeImageIndex, 1);
//     newImageList.splice(activeImageIndex, 0, clickedImage);
//     newImageList.push(bigImage);

//     setImageList(newImageList);
//     setActiveImageIndex(activeImageIndex);
//   };

//   const nextImages = () => {
//     setCurrentIndex((prevIndex) => (prevIndex + 1) % Math.ceil(imageList.length / 2));
//   };

//   const prevImages = () => {
//     setCurrentIndex((prevIndex) => (prevIndex - 1 + Math.ceil(imageList.length / 2)) % Math.ceil(imageList.length / 2));
//   };
//   const handlers = useSwipeable({
//     onSwipedLeft: nextImages,
//     onSwipedRight:prevImages,
//     preventDefaultTouchmoveEvent: true,
//     trackMouse: true,
//   });


//   return (
//     <section className="overflow-hidden  w-full h-full ">
//       <Navbar />
//       <div {...handlers} className=" relative xl:bottom-0 bg-tertiary ">
//         <div className=" relative lg:left-[81%] left-[68%] md:left-[77%] top-7 lg:bottom-6 z-10">
//           <img src={icons.trendCircles} alt="Doodle Left" className="w-32 md:w-48 lg:w-1/5" />
//         </div>

//         <div className="lg:hidden flex flex-col items-start pt-4 md:pt-0 relative left-11 bottom-12">
//           <div className="mb-0 ">
//             {/* Date */}
//             <h3 className="text-primary1 text-lg font-poppins mb-2 text-start">
//               {imageList[activeImageIndex].date}
//             </h3>
//             <h1 className="text-4xl font-outfit text-primary1 mt-2">
//               {imageList[activeImageIndex].alt}
//             </h1>

//             {/* Subheading */}
//             <h2 className="text-3xl font-outfit text-primary1 font-light mb-4 text-start">
//               {imageList[activeImageIndex].subheading}
//             </h2>

//             {/* Blog Content */}
           
//           </div>
//         </div>

//         {/* Main Content */}
//         <div className="flex flex-col lg:flex-row py-16 md:py-12 lg:py-0 px-10 lg:px-20 relative bottom-16 md:bottom-16 lg:left-12 lg:-top-8 xl:-top-40 left-1  md:flex md:flex-col ">
//           {/* Left Section: Big Image */}
//           <div className="lg:w-1/2 relative z-10">
//             <motion.div
//               key={activeImageIndex}
//               className="relative"
//               variants={fadeVariants}
//               initial="hidden"
//               animate="visible"
//               exit="exit"
//             >
//               <img
//                 src={imageList[activeImageIndex].image}
//                 alt={imageList[activeImageIndex].alt}
//                 className="w-80 md:w-[98%] lg:w-[95%] h-80 md:h-96 lg:h-screen lg:py-12 object-cover transition-opacity duration-500"
//               />
//             </motion.div>
//             <p className="lg:hidden text-sm text-hcolor font-poppins text-start my-6">
//               {imageList[activeImageIndex].description}
//             </p>
//           </div>

//           {/* Right Section: Text Content */}
//           <div className="hidden lg:block lg:w-1/2 flex-col items-start lg:pl-20 lg:py-12 ">
//             <div className="mb-0 ">
//               {/* Date */}
//               <h3 className="text-primary1 text-lg font-poppins mb-2 text-start">
//                 {imageList[activeImageIndex].date}
//               </h3>
//               <h1 className="text-4xl font-outfit text-primary1 mt-2">
//                 {imageList[activeImageIndex].alt}
//               </h1>

//               {/* Subheading */}
//               <h2 className="text-3xl font-outfit text-primary1 font-light mb-4 text-start">
//                 {imageList[activeImageIndex].subheading}
//               </h2>

//               {/* Blog Content */}
//               <p className="text-sm text-hcolor font-poppins text-start">
//                 {imageList[activeImageIndex].description}
//               </p>
//             </div>
//           </div>
//         </div>

                

//         {/* Small Images Section */}
//         <div className="lg:hidden relative bottom-24 md:bottom-20 lg:bottom-32 mr-2 z-30 flex flex-col items-center  left-2">
//           <div className="grid grid-cols-2 gap-5 px-9 md:px-10 lg:px-32">
//             {/* Display two images based on currentIndex */}
//             {imageList.slice(currentIndex, currentIndex + 2).map((img, index) => (
//               <motion.div
//                 key={index}
//                 className={`cursor-pointer transition-opacity duration-500`}
//                 onClick={() => handleImageClick(index + currentIndex)} // Update the index
//                 whileHover={{ scale: 1.05 }}
//                 whileTap={{ scale: 0.95 }}
//               >
//                 {/* Small Image */}
//                 <motion.img
//                   src={img.image}
//                   alt={img.alt}
//                   className="w-full h-full lg:w-[100%] lg:h-[130%]"
//                   initial="hidden"
//                   animate="visible"
//                   exit="exit"
//                 />

//                 {/* Dynamic Heading */}
//                 <h4 className="text-sm font-poppins font-bold text-primary1 mt-2">
//                   {img.alt} {/* Fallback text */}
//                 </h4>

//                 {/* Dynamic Subheading */}
//                 <p className="text-xs font-poppins text-hcolor z-10">
//                   {img.subheading} {/* Fallback text */}
//                 </p>
//               </motion.div>
//             ))}
//           </div>

          

//           {/* Dots Indicator */}
//           <div className="flex space-x-2 relative top-20">
//             {Array.from({ length: Math.ceil(imageList.length / 2) }).map((_, index) => (
//               <div key={index} className={`w-2 h-2 rounded-full border-primary1 ${currentIndex === index ? 'bg-primary1 ' : 'bg-primary2 '}`}></div>
//             ))}
//           </div>
          
//         </div>
        
        
//       </div>
      
//       <Footer />
//       </section>
//   );
// };

// export default Blogs;


// import { useState,useEffect } from "react";
// import { motion } from "framer-motion";
// import images from '../../images.config';
// import icons from "../../icons.config";
// import Navbar from '../Navbar/navbar';
// import Footer from '../Footer/footer';
// import { useSwipeable } from 'react-swipeable'; // Import swipeable
// import FooterDoodles from "../Footer/footerDoodles";

// const Blogs = () => {
//   const initialImages = [
//     { image: images.blog1, alt: "DIKOST DIARIES", date: "05/01/2024", subheading: "Explore the Latest Fashion Insights and Style Advice", description: "First blog post written by Author 1 Join us on a fashionable journey through personal stories, outfit experiments, and style lessons learned. Our blog shares insights from real fashionistas who navigate the world of clothing, offering inspiration and tips for your own style evolution.Join us on a fashionable journey through personal stories, outfit experiments, and style lessons learned. Our blog shares insights from real fashionistas who navigate the world of clothing, offering inspiration and tips for your own style evolution." },
//     { image: images.blog2, alt: "FASHION CHRONICLES", date: "12/02/2024", subheading: "Stay Updated with Trends, Styling Ideas, and Expert Tips", description: "Second blog post written by Author 2 Keep your wardrobe in tune with the seasons! Our seasonal style blog explores the must-have clothing items for each time of year. From summer dresses to winter layers, we provide inspiration for dressing stylishly in any weather while keeping comfort in mind.Join us on a fashionable journey through personal stories, outfit experiments, and style lessons learned. Our blog shares insights from real fashionistas who navigate the world of clothing, offering inspiration and tips for your own style evolution." },
//     { image: images.blog3, alt: "THE DIKOST EDIT", date: "20/03/2024", subheading: "Discover Fashion Trends, Style Tips, and Exclusive Insights", description: "Third blog post written by Author 3 Stay ahead of the curve with our fashion-forward blog! We cover emerging designers, innovative styles, and the latest must-have pieces. Whether you’re looking for high-fashion inspiration or everyday wear, we’ve got you covered with expert advice and trend analysis." },
//     { image: images.blog4, alt: "STYLE JOURNAL", date: "15/04/2024", subheading: "Your Source for Fashion Inspiration and Latest Trends", description: "Fourth blog post written by Author 4 lorem Ready to revamp your wardrobe? Our blog is dedicated to helping you find your personal style and rejuvenate your clothing collection. We share tips on mixing and matching, accessorizing, and making the most of what you already own. Join us for a style journey that’s both fun and refreshing!Join us on a fashionable journey through personal stories, outfit experiments, and style lessons learned. Our blog shares insights from real fashionistas who navigate the world of clothing, offering inspiration and tips for your own style evolution.Join us on a fashionable journey through personal stories, outfit experiments, and style lessons learned. Our blog shares insights from real fashionistas who navigate the world of clothing, offering inspiration and tips for your own style evolution." },
//     { image: images.blog5, alt: "STYLE STORIES", date: "01/05/2024", subheading: "Your Guide to Fashion Trends, Tips, and Inspiration", description: "Fifth blog post written by Author 5 Dive into the world of eco-friendly fashion with our sustainable clothing blog. We highlight brands that prioritize ethical production, sustainable materials, and stylish designs. Learn how to build a wardrobe that not only looks good but feels good too—because style shouldn’t come at the cost of the planet.Join us on a fashionable journey through personal stories, outfit experiments, and style lessons learned. Our blog shares insights from real fashionistas who navigate the world of clothing, offering inspiration and tips for your own style evolution." }, // Initial big image
//   ];



//   const [imageList, setImageList] = useState(initialImages);
//   const [activeImageIndex, setActiveImageIndex] = useState(4); // Index of the big image initially
//   const [currentIndex, setCurrentIndex] = useState(0); // Index for the small images
  
  

 

//   const fadeVariants = {
//     hidden: { opacity: 0 },
//     visible: { opacity: 1, transition: { duration: 0.3 } },
//     exit: { opacity: 0, transition: { duration: 0.5 } },
//   };

//   const handleImageClick = (clickedIndex) => {
//     const newImageList = [...imageList];

//     // Swap the clicked image with the big image
//     const bigImage = newImageList[activeImageIndex];
//     const clickedImage = newImageList.splice(clickedIndex, 1)[0];

//     newImageList.splice(activeImageIndex, 1);
//     newImageList.splice(activeImageIndex, 0, clickedImage);
//     newImageList.push(bigImage);

//     setImageList(newImageList);
//     setActiveImageIndex(activeImageIndex);
//   };

//   const nextImages = () => {
//     setCurrentIndex((prevIndex) => (prevIndex + 1) % Math.ceil(imageList.length / 2));
//   };

//   const prevImages = () => {
//     setCurrentIndex((prevIndex) => (prevIndex - 1 + Math.ceil(imageList.length / 2)) % Math.ceil(imageList.length / 2));
//   };
  

//   const handlers = useSwipeable({
//     onSwipedLeft: nextImages,
//     onSwipedRight: prevImages,
//     preventDefaultTouchmoveEvent: true,
//     trackMouse: true,
//   });
  
//   const nextSlide = () => {
//     if (imageList.length === 0) return; // Early exit if no images

//     setImageList((prevList) => {
//         const updatedList = [...prevList];
//         const firstItem = updatedList.shift(); // Remove the first item
//         updatedList.push(firstItem); // Add it to the end
//         return updatedList;
//     });

//     setCurrentIndex((prevIndex) => (prevIndex + 1) % imageList.length); // Maintain correct index update
//     console.log("next arrow clicked");
// };

// const prevSlide = () => {
//     if (imageList.length === 0) return; // Early exit if no images

//     setImageList((prevList) => {
//         const updatedList = [...prevList];
//         const lastItem = updatedList.pop(); // Remove the last item
//         updatedList.unshift(lastItem); // Add it to the beginning
//         return updatedList;
//     });

//     setCurrentIndex((prevIndex) => (prevIndex - 1 + imageList.length) % imageList.length); // Maintain correct index update
//     console.log("prev arrow clicked");
// };
 

  
  
  
  
//   return (
//     <section className="overflow-hidden w-full h-full">
//       <Navbar />
//       <div {...handlers} className="relative xl:bottom-0 bg-tertiary">
//         <div className="relative lg:left-[81%] left-[68%] md:left-[77%] top-7 lg:-top-7 z-10">
//           <img src={icons.trendCircles} alt="Doodle Left" className="w-32 md:w-48 lg:w-1/5" />
//         </div>
//         <div className="hidden lg:block relative left-2 bottom-40 h-10">
//           <img src={icons.blogFlower1} alt="Doodle Left" className="w-24 md:w-48 lg:w-28" />
//         </div>

//         <div className="xl:hidden flex flex-col items-start pt-4 md:pt-0 relative left-11 lg:left-20 bottom-12 ">
//           <div className="mb-0">
//             <h3 className="text-hcolor text-md  font-poppins font-light mb-2 text-start">
//               {initialImages[activeImageIndex].date}
//             </h3>
//             <h1 className="text-2xl font-outfit text-primary1 mt-2 font-normal">
//               {imageList[activeImageIndex].alt}
//             </h1>

//             <h2 className="text-lg font-outfit text-primary1 font-light  text-start mt-5 pr-8">
//               {imageList[activeImageIndex].subheading}
//             </h2>
//           </div>
//         </div>

//         <div className="flex flex-col xl:flex-row py-16 md:py-12 lg:py-0 px-10 lg:px-20 relative bottom-16 md:bottom-16 xl:left-12 lg:-top-8 xl:-top-52 left-1 md:flex md:flex-col">
//           <div className="xl:w-1/2 relative z-10">
//             <motion.div
//               key={activeImageIndex}
//               className="relative"
//               variants={fadeVariants}
//               initial="hidden"
//               animate="visible"
//               exit="exit"
//             >
//               <img
//                 src={imageList[activeImageIndex].image}
//                 alt={imageList[activeImageIndex].alt}
//                 className="w-80 md:w-[98%]  xl:w-[93%] h-80 md:h-96 lg:h-screen lg:py-8 object-cover transition-opacity duration-500"
//               />
//             </motion.div>
//             <p className="xl:hidden text-lg lg:text-base text-hcolor font-poppins font-light text-start my-6 ">
//               {imageList[activeImageIndex].description}
//             </p>
//             <button className='xl:hidden border-2 py-2 px-4 flex text-primary2 font-outfit font-medium bg-hcolor hover:bg-primary2 hover:text-hcolor transition-all duration-500 ease-in-out relative top-0 md:top-2 '>
//           READ MORE
//         </button>
//           </div>

//           <div className="hidden xl:block xl:w-1/2 flex-col items-start xl:pl-20 lg:py-8">
//             <div className="mb-0">
//               <h3 className="text-hcolor text-md font-light font-poppins mb-4 text-start">
//                 {imageList[activeImageIndex].date}
//               </h3>
//               <h1 className="text-4xl font-outfit font-normal text-primary1 mt-2 mb-7">
//                 {imageList[activeImageIndex].alt}
//               </h1>

//               <h2 className="text-2xl font-outfit text-primary1 font-normal mb-4 text-start pr-20">
//                 {imageList[activeImageIndex].subheading}
//               </h2>

//               <p className="text-md text-hcolor font-poppins font-light text-start pr-24">
//                 {imageList[activeImageIndex].description}
//               </p>
//               <button className='border-2 py-2 px-4 flex text-primary2 font-outfit font-medium bg-hcolor hover:bg-primary2 hover:text-hcolor transition-all duration-500 ease-in-out absolute bottom-8 mt-1'>
//           READ MORE
//         </button>
//             </div>

//           </div>
//         </div>

//         {/* Small Images Section */}
//         <div className="hidden lg:grid lg:grid-cols-4 gap-5 px-9 md:px-10 lg:px-20 xl:px-32 relative lg:bottom-3 lg:mt-5 lg:mb-20 xl:mb-0 xl:bottom-32 mr-2 z-30">
//         <img src={icons.arrowLeft} alt="left arrow"
//           className="absolute lg:left-16 xl:left-28 top-[60%] transform -translate-y-1/2 text-primary1 text-lg font-semibold w-8 h-8 rounded-[50%] z-20 bg-secondary hidden lg:block opacity-70"
//           onClick={prevSlide}
//         />
//           {imageList.slice(0, 4).map((img, index) => (
//             <motion.div
//               key={index}
//               className={`cursor-pointer transition-opacity duration-500`}
//               onClick={() => handleImageClick(index)}
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//             >
//               <motion.img
//                 src={img.image}
//                 alt={img.alt}
//                 className="w-full h-full lg:w-[100%] lg:h-[120%]"
//                 initial="hidden"
//                 animate="visible"
//                 exit="exit"
//               />
//               <h4 className="text-lg font-poppins font-normal text-primary1 mt-2">
//                 {img.alt} {/* Fallback text */}
//               </h4>
//               <p className="text-sm font-poppins text-hcolor font-light z-10">
//                 {img.subheading} {/* Fallback text */}
//               </p>
//             </motion.div>
//           ))}
//             <img src={icons.arrowRight} alt="right arrow"
//           className="absolute top-[60%] lg:right-16 xl:right-28 transform -translate-y-1/2  hidden text-primary1 rounded-[50%] bg-secondary  lg:block w-8 h-8 z-10 opacity-70"
//           onClick={nextSlide}
//         />
//         </div>

//         {/* Small Images Section */}
//          <div className="lg:hidden relative bottom-24 md:bottom-12 lg:bottom-32 mr-2 z-30 flex flex-col items-center  left-2">
//            <div className="grid grid-cols-2 gap-5 px-9 md:px-10 lg:px-32">
//              {/* Display two images based on currentIndex */}
//              {imageList.slice(currentIndex, currentIndex + 2).map((img, index) => (
//                <motion.div
//                  key={index}
//                  className={`cursor-pointer transition-opacity duration-500`}
//                  onClick={() => handleImageClick(index + currentIndex)} // Update the index
//                  whileHover={{ scale: 1.05 }}
//                  whileTap={{ scale: 0.95 }}
//                >
//                  {/* Small Image */}
//                  <motion.img
//                    src={img.image}
//                    alt={img.alt}
//                    className="w-full h-full lg:w-[100%] lg:h-[130%]"
//                    initial="hidden"
//                    animate="visible"
//                    exit="exit"
//                  />

//                  {/* Dynamic Heading */}
//                  <h4 className="text-md font-poppins font-normal text-primary1 mt-2">
//                    {img.alt} {/* Fallback text */}
//                  </h4>

//                  {/* Dynamic Subheading */}
//                  <p className="text-xs font-poppins font-light text-hcolor z-10">
//                    {img.subheading} {/* Fallback text */}
//                  </p>
//                </motion.div>
//              ))}
            
//            </div>

          

//            {/* Dots Indicator */}
//            <div className="flex space-x-2 relative top-28 md:top-24">
//              {Array.from({ length: Math.ceil(imageList.length / 2) }).map((_, index) => (
//                <div key={index} className={`w-2 h-2 rounded-full border-primary1 ${currentIndex === index ? 'bg-primary1 ' : 'bg-primary2 '}`}></div>
//              ))}
//            </div>
          
//          </div>
//           <div className="relative lg:left-[89%] left-[80%] md:left-[84%] top-2 md:top-8 lg:top-1 z-20 h-10">
//           <img src={icons.blogFlower2} alt="Doodle Left" className="w-16 md:w-20 lg:w-28" />
//         </div>
//       </div>
// <FooterDoodles/>
//       <Footer />
//     </section>
//   );
// };

// export default Blogs;

import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import icons from "../../icons.config";
import Navbar from '../Navbar/navbar';
import Footer from '../Footer/footer';
import { useSwipeable } from 'react-swipeable'; 
import FooterDoodles from "../Footer/footerDoodles";

import { fetchBlogData } from "../../Providers/blogsProvider";
import { IMAGE_BASE_URL } from "../../api-urls";

const Blogs = () => {
  const [imageList, setImageList] = useState([]);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getBlogs = async () => {
      const { data, error } = await fetchBlogData();
      if (data) {
        setImageList(data);
        setLoading(false);
      } else {
        setError(error);
        setLoading(false);
      }
    };

    getBlogs();
  }, []);

  

  const fadeVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.3 } },
    exit: { opacity: 0, transition: { duration: 0.5 } },
  };

  const handleImageClick = (clickedIndex) => {
    const newImageList = [...imageList];
    const bigImage = newImageList[activeImageIndex];
    const clickedImage = newImageList.splice(clickedIndex, 1)[0];

    newImageList.splice(activeImageIndex, 1);
    newImageList.splice(activeImageIndex, 0, clickedImage);
    newImageList.push(bigImage);

    setImageList(newImageList);
    setActiveImageIndex(activeImageIndex);
  };

  const nextImages = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % Math.ceil(imageList.length / 2));
  };

  const prevImages = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + Math.ceil(imageList.length / 2)) % Math.ceil(imageList.length / 2));
  };

  const handlers = useSwipeable({
    onSwipedLeft: nextImages,
    onSwipedRight: prevImages,
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  const nextSlide = () => {
    if (imageList.length === 0) return;

    setImageList((prevList) => {
      const updatedList = [...prevList];
      const firstItem = updatedList.shift();
      updatedList.push(firstItem);
      return updatedList;
    });

    setCurrentIndex((prevIndex) => (prevIndex + 1) % imageList.length);
  };

  const prevSlide = () => {
    if (imageList.length === 0) return;

    setImageList((prevList) => {
      const updatedList = [...prevList];
      const lastItem = updatedList.pop();
      updatedList.unshift(lastItem);
      return updatedList;
    });

    setCurrentIndex((prevIndex) => (prevIndex - 1 + imageList.length) % imageList.length);
  };

  if (loading) {
    return <div className="text-center py-10 text-lg">Loading Blogs...</div>;
  }

  if (error) {
    return <div className="text-center py-10 text-red-500">Error: {error}</div>;
  }

  return (
    <section className="overflow-hidden w-full h-full">
      <Navbar />
      <div {...handlers} className="relative xl:bottom-0 bg-tertiary">
        <div className="relative lg:left-[81%] left-[68%] md:left-[77%] top-7 lg:-top-7 z-10">
          <img src={icons.trendCircles} alt="Doodle Left" className="w-32 md:w-48 lg:w-1/5" />
        </div>
        <div className="hidden lg:block relative left-2 bottom-40 h-10">
           <img src={icons.blogFlower1} alt="Doodle Left" className="w-24 md:w-48 lg:w-28" />
         </div>

        <div className="flex flex-col xl:flex-row py-16 md:py-12 lg:py-0 px-10 lg:px-20 relative bottom-16 md:bottom-16 xl:left-12 lg:-top-8 xl:-top-52 left-1 md:flex md:flex-col">
        <div className="xl:w-1/2 relative z-10">
  <motion.div
    key={activeImageIndex}
    className="relative w-80 md:w-[98%] xl:w-[93%] h-80 md:h-96 lg:h-screen lg:py-8 overflow-hidden"
    variants={fadeVariants}
    initial="hidden"
    animate="visible"
    exit="exit"
  >
    <img
      src={IMAGE_BASE_URL + imageList[activeImageIndex]?.thumbnail}
      alt={imageList[activeImageIndex]?.alt}
      className="w-full h-full object-cover transition-opacity duration-500"
    />
  </motion.div>
  <p className="xl:hidden text-lg lg:text-base text-hcolor font-poppins font-light text-start my-6">
    {imageList[activeImageIndex]?.blog}
  </p>
  <button className="xl:hidden border-2 py-2 px-4 flex text-primary2 font-outfit font-medium bg-hcolor hover:bg-primary2 hover:text-hcolor transition-all duration-500 ease-in-out">
    READ MORE
  </button>
</div>


          <div className="hidden xl:block xl:w-1/2 flex-col items-start xl:pl-20 lg:py-8">
            <h3 className="text-hcolor text-md font-light font-poppins mb-4 text-start">
            {imageList[activeImageIndex]?.createdAt &&
  new Date(imageList[activeImageIndex].createdAt).toLocaleDateString()}

            </h3>
            <h1 className="text-4xl font-outfit font-normal text-primary1 mt-2 mb-7">
              {imageList[activeImageIndex]?.title}
            </h1>
            <h2 className="text-2xl font-outfit text-primary1 font-normal mb-4 text-start pr-20">
              {imageList[activeImageIndex]?.description}
            </h2>
            <p className="text-md text-hcolor font-poppins font-light text-start pr-24">
              {imageList[activeImageIndex]?.blog}
            </p>
            <button className='border-2 py-2 px-4 flex text-primary2 font-outfit font-medium bg-hcolor hover:bg-primary2 hover:text-hcolor transition-all duration-500 ease-in-out relative top-[38%] 2xl:top-[33%]'>
              READ MORE
            </button>
          </div>
        </div>
                 {/* Small Images Section */}
                 <div className="hidden lg:grid lg:grid-cols-4 gap-5 px-9 md:px-10 lg:px-20 xl:px-32 relative lg:bottom-3 lg:mt-5 lg:mb-20 xl:mb-0 xl:bottom-32 mr-2 z-30">
  {/* Left Arrow */}
  <img 
    src={icons.arrowLeft} 
    alt="left arrow"
    className="absolute lg:left-16 xl:left-28 top-[60%] transform -translate-y-1/2 text-primary1 text-lg font-semibold w-8 h-8 rounded-[50%] z-20 bg-secondary hidden lg:block opacity-70"
    onClick={prevSlide}
  />

  {imageList.slice(0, 4).map((img, index) => (
    <motion.div
      key={index}
      className="cursor-pointer transition-opacity duration-500 w-full h-[250px] lg:h-[300px] xl:h-[350px] "
      onClick={() => handleImageClick(index)}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <motion.img
        src={IMAGE_BASE_URL + img.thumbnail}
        alt={img.alt}
        className="w-full h-full object-cover"
        initial="hidden"
        animate="visible"
        exit="exit"
      />
      <h4 className="text-lg font-poppins font-normal text-primary1 mt-2">
        {img.title} {/* Fallback text */}
      </h4>
      <p className="text-sm font-poppins text-hcolor font-light z-10">
        {img.description} {/* Fallback text */}
      </p>
    </motion.div>
  ))}

  {/* Right Arrow */}
  <img 
    src={icons.arrowRight} 
    alt="right arrow"
    className="absolute top-[60%] lg:right-16 xl:right-28 transform -translate-y-1/2 hidden text-primary1 rounded-[50%] bg-secondary lg:block w-8 h-8 z-10 opacity-70"
    onClick={nextSlide}
  />
</div>


        {/* Small Images Section */}
         <div className="lg:hidden relative bottom-24 md:bottom-12 lg:bottom-32 mr-2 z-30 flex flex-col items-center  left-2">
           <div className="grid grid-cols-2 gap-5 px-9 md:px-10 lg:px-32">
             {/* Display two images based on currentIndex */}
             {imageList.slice(currentIndex, currentIndex + 2).map((img, index) => (
               <motion.div
                 key={index}
                 className={`cursor-pointer transition-opacity duration-500`}
                 onClick={() => handleImageClick(index + currentIndex)} // Update the index
                 whileHover={{ scale: 1.05 }}
                 whileTap={{ scale: 0.95 }}
               >
                 {/* Small Image */}
                 <motion.img
                   src={IMAGE_BASE_URL+img.thumbnail}
                   alt={img.alt}
                   className="w-full h-full lg:w-[100%] lg:h-[130%]"
                   initial="hidden"
                   animate="visible"
                   exit="exit"
                 />

                 {/* Dynamic Heading */}
                 <h4 className="text-md font-poppins font-normal text-primary1 mt-2">
                   {img.title} {/* Fallback text */}
                 </h4>

                 {/* Dynamic Subheading */}
                 <p className="text-xs font-poppins font-light text-hcolor z-10">
                   {img.description} {/* Fallback text */}
                 </p>
               </motion.div>
             ))}
            
           </div>

          

           {/* Dots Indicator */}
           <div className="flex space-x-2 relative top-28 md:top-24">
             {Array.from({ length: Math.ceil(imageList.length / 2) }).map((_, index) => (
               <div key={index} className={`w-2 h-2 rounded-full border-primary1 ${currentIndex === index ? 'bg-primary1 ' : 'bg-primary2 '}`}></div>
             ))}
           </div>
          
         </div>
      </div>
      <FooterDoodles />
      <Footer />
    </section>
  );
};

export default Blogs;
